import { cleanEmptyFilters } from '../../../common/support/utils/druid/updateQuery';

export class DruidQueryFilterService {
  cleanEmptyFilters = (query) => {
    let updatedQuery = query;
    if (updatedQuery.filter) {
      updatedQuery = {
        ...updatedQuery,
        filter: cleanEmptyFilters(updatedQuery.filter, true),
      };
    }
    return updatedQuery;
  };
}
